interface Props {
  text: string;
}

export default function ParagraphDescription({ text }: Props) {
  return (
    <div className="w-full relative flex flex-col">
      <div className="flex w-full h-full min-h-[38px] flex-row gap-1">
        <p dangerouslySetInnerHTML={{ __html: text }} className="bg-white flex h-full rounded-[7px] font-medium text-xs text-justify">
        {/* <p className="bg-white flex h-full rounded-[7px] font-medium text-xs text-justify">
          {text} */}
        </p>
      </div>
    </div>
  );
}
